import { migrationQueueApi } from "./migrationQueue";
import { createQueueSearchLoader } from "@/lib/queueSearch";
// Shared per browser module lifetime; metadata is reauthorized on every load.
export const readJumpstartQueueSearchState = createQueueSearchLoader(
  migrationQueueApi.state,
);
